<ion-grid>
    <ion-row class="ion-justify-content-center" *ngIf="!loading">
        <ion-col
            size="12"
            size-xs="12"
            size-sm="12"
            size-md="10"
            size-lg="6"
            size-xl="6"
        >
            <ion-list>
                <ion-list-header>
                    <ion-label>Additional Documents</ion-label>
                </ion-list-header>
                <ion-item
                    *ngFor="let document of documents"
                    class="ion-margin-top"
                >
                    <ion-label>
                        <div class="app-item-title">{{ document?.name }}</div>
                    </ion-label>
                    <ion-button
                        class="application-document-btn"
                        slot="end"
                        fill="clear"
                        color="secondary"
                        (click)="viewDocument(document)"
                    >
                        View Document
                    </ion-button>
                    <ion-button
                        class="application-document-btn"
                        slot="end"
                        fill="clear"
                        color="medium"
                        (click)="clearAdditionalReqDocument(document)"
                    >
                        Clear
                    </ion-button>
                </ion-item>
                <ion-item
                    *ngIf="documents.length === 0"
                    lines="none"
                    class="ion-text-center"
                >
                    <ion-label *ngIf="!loading" class="no-apps-text bold">
                        <fa-icon
                            [icon]="faExclamationCircle"
                            class="fa-line-padding"
                            style="color: var(--ion-color-primary)"
                        >
                        </fa-icon
                        >You have no additional documents uploaded for this
                        application.
                    </ion-label>
                    <ion-label *ngIf="loading" class="no-apps-text bold">
                        <ion-spinner name="circular"></ion-spinner>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-center" *ngIf="!loading">
        <ion-col
            size="12"
            size-xs="12"
            size-sm="12"
            size-md="10"
            size-lg="6"
            size-xl="6"
        >
            <div class="ion-text-center">
                <ion-list>
                    <ion-list-header>
                        <ion-label>Malpractice</ion-label>
                    </ion-list-header>
                    <ion-item
                        *ngFor="let document of malpracticeDocuments"
                        class="ion-margin-top"
                    >
                        <ion-label>
                            <div class="app-item-title">
                                {{ document?.filename }}
                            </div>
                        </ion-label>
                        <ion-button
                            class="application-document-btn"
                            slot="end"
                            fill="clear"
                            color="secondary"
                            (click)="viewMalpracticeDocument(document)"
                        >
                            View Document
                        </ion-button>
                    <ion-button
                        class="application-document-btn"
                        slot="end"
                        fill="clear"
                        color="medium"
                        (click)="clearMalpracticeDocument(document)"
                    >
                        Clear
                    </ion-button>
                    </ion-item>
                    <ion-item
                        *ngIf="malpracticeDocuments.length === 0"
                        lines="none"
                        class="ion-text-center"
                    >
                        <ion-label *ngIf="!loading" class="no-apps-text bold">
                            <fa-icon
                                [icon]="faExclamationCircle"
                                class="fa-line-padding"
                                style="color: var(--ion-color-primary)"
                            >
                            </fa-icon
                            >You have no malpractice documents uploaded for this
                            application.
                        </ion-label>
                        <ion-label *ngIf="loading" class="no-apps-text bold">
                            <ion-spinner name="circular"></ion-spinner>
                        </ion-label>
                    </ion-item>
                </ion-list>
            </div>
        </ion-col>
    </ion-row>
    <ion-row *ngIf="loading">
        <ion-col size="12">
            <ion-skeleton-text
                animated
                style="width: 50%"
                *ngFor="let item of loadingText"
            ></ion-skeleton-text>
        </ion-col>
    </ion-row>
</ion-grid>
